import { render, staticRenderFns } from "./RenderStar.vue?vue&type=template&id=7ddd2b26"
import script from "./RenderStar.vue?vue&type=script&lang=ts"
export * from "./RenderStar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports